<div class="parent-container">
  <div class="centered-div">
    <div class="rate-left-heading">
      <h2 class="rate-header-style">Rates</h2>
      <p class="rate-text-style">Check Out Our Transload Rates</p>
    </div>
    <div class="container">
      <div class="box-rates">
        <div class="image-container">
          <img [src]="lumberPath" alt="Lumber Image" />
        </div>
        <div class="content">
          <h4>Lumber Rates</h4>
          <p>
            Processed wood used for construction, furniture and manufacturing.
          </p>
          <div class="btn-container">
            <up-button button-style="outlined" (click)="openNewTab('lumberHistory')"
              >VIEW RATES
            </up-button>
          </div>
        </div>
      </div>
      <div class="box-rates">
        <div class="image-container">
          <img [src]="producePath" alt="Produce Image" />
        </div>
        <div class="content">
          <h4>Produce Rates</h4>
          <p>
            Fresh potatoes and onions that require proper storage and
            transportation.
          </p>
          <div class="btn-container">
            <up-button button-style="outlined" (click)="openNewTab('produceHistory')"
              >VIEW RATES
            </up-button>
          </div>
        </div>
      </div>
      <div class="box-rates">
        <div class="image-container">
          <img [src]="metalsPath" alt="Metals Image" />
        </div>
        <div class="content">
          <h4>Metals Rates</h4>
          <p>Raw or processed metals used in construction and manufacturing.</p>
          <div class="btn-container">
            <up-button button-style="outlined" (click)="openNewTab('metalsHistory')"
              >VIEW RATES
            </up-button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-customer">
      <app-custom-rate class="banner-width"></app-custom-rate>
    </div>
  </div>
</div>
